/**
 * Search domain schema, derived from the generated Zod.
 *
 * `invoices[].property` / `tickets[].property` arrive null when the linked
 * property was deleted (both FKs are SET_NULL), but the generated base types
 * every nested `property` required non-null. `cars[].property` has no such gap
 * — `Car.prop` is CASCADE/non-null — so it stays inherited.
 */
import { z } from 'zod';

import { SearchRetrieveResponse } from '~/data/generated/zod/search/search.zod';

const searchInvoiceSchema = SearchRetrieveResponse.shape.invoices.element.extend({
  property: SearchRetrieveResponse.shape.invoices.element.shape.property.nullable(),
});

const searchTicketSchema = SearchRetrieveResponse.shape.tickets.element.extend({
  property: SearchRetrieveResponse.shape.tickets.element.shape.property.nullable(),
});

export const searchResultsSchema = SearchRetrieveResponse.extend({
  invoices: z.array(searchInvoiceSchema),
  tickets: z.array(searchTicketSchema),
});
